import { PayloadAction } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { authApi } from '../../api/authApi';
import { Account, LoginInfo } from '../../models';
import { authActions } from './authSlice';

function* handleLogin(action: PayloadAction<Account>) {
  try {
    const res: LoginInfo = yield call(authApi.login, action.payload);
    localStorage.setItem('access_token', res.token);
    localStorage.setItem('refresh_token', res.refresh_token);
    localStorage.setItem('plantItemSidebar', '');
    localStorage.setItem('inverterItemSidebar', '');
    localStorage.setItem('isValueNavUser', '1');
    localStorage.setItem('isValueNavInverter', '1');
    localStorage.setItem('isValueNavPlant', '1');
    yield put(authActions.loginSuccess());
    yield put(push('/user/home'));
  } catch (error: any) {
    yield put(authActions.loginFailed('Wrong Username or password'));
  }
}

function* handleLogout() {
  yield localStorage.clear();
  yield put(push('/'));
}

function* watchLoginFlow() {
  yield takeLatest(authActions.login.type, handleLogin);
  yield takeLatest(authActions.logout.type, handleLogout);
}

export default function* authSaga() {
  yield fork(watchLoginFlow);
}
